//
//
//
//
//
//
//

export default {
  props: {
    index: {
      type: Number,
      default: 1
    },
    track: {
      type: Object,
      default: null
    },
    ownner: {
      type: String,
      default: null
    }
  },

  computed: {
    title () {
      return this.whenTrackExist(() => this.track.get('title'))
    },

    isAudioUrlEmpty () {
      return this.track && this.track.get('audioUrl')
    }

  },

  methods: {
    clickMusicListItem () {
      this.$emit('click-item', this.index)
    },

    whenTrackExist (getAimProper) {
      return this.track ? getAimProper() : ""
    },
  }
}  



// WEBPACK FOOTER //
// ./src/components/music_player/MusicListItem.vue